import React from 'react';

const OnIcon = () => {
  return (
    <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transform: 'scale(1.4)'}}>
      <g filter="url(#filter0_d_150_1805)">
        <rect x="2" y="1.5" width="24" height="24" rx="12" fill="#4B1C46"/>
      </g>
      <path d="M10.1571 8.60498C8.57503 9.76488 7.54297 11.6314 7.54297 13.7438C7.54297 17.2639 10.3968 20.1174 13.9169 20.1174C17.4373 20.1174 20.2909 17.2639 20.2909 13.7438C20.2909 11.6314 19.2591 9.76488 17.6767 8.60498" stroke="white" strokeWidth="1.37143" strokeLinecap="round"/>
      <path d="M13.7742 6.75195V13.0899" stroke="white" strokeWidth="1.37143" strokeLinecap="round"/>
      <defs>
        <filter id="filter0_d_150_1805" x="0.628571" y="0.128571" width="26.7429" height="26.7429" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="0.685714"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_150_1805"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_150_1805" result="shape"/>
        </filter>
      </defs>
    </svg>

  );
};

export default OnIcon;
